// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as monitorActions from '../../../actions/monitors';
import MonitorCard from '../../MonitorCard';
import StopCard from '../../StopCard';

import mapViewStyles from '../MapView/mapView.css';


type StudentPropTypes = {
  monitorId: number,
  match: Object,
  startFetchingMonitor: Function,
};

class MapMonitorView extends Component<StudentPropTypes> {
  componentDidMount() {
    const { monitorId, startFetchingMonitor } = this.props;
    startFetchingMonitor(monitorId);
  }

  componentDidUpdate(prevProps) {
    const { match, startFetchingMonitor } = this.props;
    if (parseInt(match.params.id, 10) !== parseInt(prevProps.match.params.id, 10)) {
      startFetchingMonitor(match.params.id);
    }
  }

  render() {
    const { monitorId } = this.props;
    return (
      <Fragment>
        <div className={mapViewStyles.cardContainer}>
          <MonitorCard id={monitorId} />
        </div>
        <StopCard />
      </Fragment>
    );
  }
}

export default connect(
  (state, ownProps) => {
    const monitorId = parseInt(ownProps.match.params.id, 10);
    return { monitorId };
  },
  dispatch => ({
    startFetchingMonitor(id) {
      dispatch(monitorActions.startFetchingMonitor(id));
      dispatch(monitorActions.startFetchingMonitorRoutes(id));
    },
  }),
)(withRouter(MapMonitorView));



// WEBPACK FOOTER //
// ./src/scripts/components/views/MapMonitorView/index.jsx